import PubSub from "underpub-js";
import sharerjs from 'sharer.js';

var ShareSnippet = function (options) {

  this.options = {
    $el: false,
    baseClass: 'el-ShareSnippet',
  };

  $.extend(true, this.options, options);

};

ShareSnippet.prototype.init = function () {

  var self = this;

};

export default ShareSnippet;